export default __webpack_public_path__ + "static/01-01-prepare-edit-anything-cca01049e498522108d771b1917ad87a.mp4";